import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import type { BoardPreviewMap } from 'webapp-types';

import type Board from 'webapp/models-custom/board';
import type BoardLoop from 'webapp/models-custom/board-loop';
import PreviewUrlManager from 'webapp/models-custom/preview-url-manager';

export default abstract class BoardOrLoopPreviewController extends Controller {
	abstract override model: BoardLoop | Board;
	abstract rootUrlWithoutId: string;

	@tracked previewUrlManager: PreviewUrlManager | null = null;

	get previewMap() {
		return this.previewUrlManager?.previewMap || {};
	}

	@action
	updatePreviewMap(previewMap: BoardPreviewMap) {
		const previewUrlManager = this.previewUrlManager;
		if (previewUrlManager) {
			previewUrlManager.previewMap = previewMap;
		}
	}

	@action
	updateBoardIdParam(id: string) {
		const previewUrlManager = this.previewUrlManager;
		if (previewUrlManager) {
			previewUrlManager.itemIdParam = id;
		}
	}

	activate() {
		this.previewUrlManager = new PreviewUrlManager(`${this.rootUrlWithoutId}/${this.model.id}`);
	}
}
